// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2mMnH","comment":"styles_comment__23JHS"};